<template>
  <div id="app">
    <PinPid />
  </div>
</template>

<script>
import PinPid from './components/PinPid.vue'

export default {
  name: 'App',
  components: {
    PinPid
  },
  mounted: function() {
    const that = this;
    const appEll = document.querySelector('#app');
    const resizeObserver = new ResizeObserver((entries) => {
      for (const entry of entries) {
        if (entry.contentRect) {
          that.changeDimensions(entry.contentRect.height)
        }
      }
    });
    resizeObserver.observe(appEll);
    this.changeDimensions(appEll.offsetHeight);
  },
  methods: {
    changeDimensions(appEl) {
      window.parent.postMessage({ iframeHeight: appEl });
    }
  }
}
</script>

<style>
@import './assets/css/main.css';
</style>
